import BaseModelInstance from './base.model'
import { WheelOfLoveWinner as ModelDefinition } from './model-definitions'

class WheelOfLoveWinner extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default WheelOfLoveWinner
